import { includesIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
import { AnalysisState, Origin, SupportFileType, AnalysisStatus, AnalysisType, ScorecardRequestState, TimeUnit } from "@ane/exp-data/lib/models/expapiv2/AnalysisModels";
import { AnalysisTaskState, JobProfileType } from "../models/Task.js";
const convertToRawStudy = (analysisV2) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w;
  return {
    Id: +analysisV2.id,
    WorkspaceId: ((_a = analysisV2.experimentMetadata) == null ? void 0 : _a.workspaceId) || "",
    ManagementGroup: "",
    // vNext APIs only provides experimentation group id.
    ExperimentationGroup: ((_b = analysisV2.experimentMetadata) == null ? void 0 : _b.experimentationGroup) || "",
    Name: ((_c = analysisV2.analysisTemplate) == null ? void 0 : _c.name) || "",
    // Analysis Template Name and Study name are same.
    Description: analysisV2.name,
    ExperimentStepId: ((_d = analysisV2.experimentMetadata) == null ? void 0 : _d.experimentStepId) || "",
    LegacyExperimentId: 0,
    AnalysisPortfolioId: 0,
    // This internal id no longer available as part of vNext API response.
    IsActive: analysisV2.state === AnalysisState.Active,
    IsAdvancedAnalysis: !!analysisV2.isAdvancedAnalysis,
    IsAuto: true,
    Status: ((_e = analysisV2.status) == null ? void 0 : _e.toString()) || "Not Started",
    BaseOnTemplate: ((_f = analysisV2.analysisTemplate) == null ? void 0 : _f.name) || "",
    MetricSetVersion: ((_g = analysisV2.analysisTemplate) == null ? void 0 : _g.metricSetVersion) || null,
    ForayProfileNameOverride: ((_i = (_h = analysisV2.analysisTemplate) == null ? void 0 : _h.analysisTemplateOverrides) == null ? void 0 : _i.forayProfileNameOverride) || null,
    IsParametrizationEnabled: !!((_j = analysisV2.analysisTemplate) == null ? void 0 : _j.isParameterizationEnabled),
    CloneFromStudyId: 0,
    TaskSchedule: {
      StartDate: ((_l = (_k = analysisV2.analysisPeriod) == null ? void 0 : _k.startDateTime) == null ? void 0 : _l.toString()) || null,
      EndDate: ((_n = (_m = analysisV2.analysisPeriod) == null ? void 0 : _m.endDateTime) == null ? void 0 : _n.toString()) || null,
      DateRangeRoundingRuleName: ((_p = (_o = analysisV2.analysisTemplate) == null ? void 0 : _o.roundingRule) == null ? void 0 : _p.name) || null,
      IsUtc: ((_q = analysisV2.analysisTemplate) == null ? void 0 : _q.isUtc) || true,
      IncludeFlightBurnInPeriod: true,
      // this is deprecated in vNext.
      ValidFinalScorecardDurationDays: ((_r = analysisV2.analysisTemplate) == null ? void 0 : _r.validFinalScorecardDurationDays) || null,
      Tasks: ((_s = analysisV2.scorecardRequests) == null ? void 0 : _s.map((scorecardRequest) => {
        return convertToRawStudyTaskEntity(scorecardRequest);
      })) || []
    },
    Scope: getAnalysisScope(analysisV2),
    CanaryTaskConfiguration: null,
    AdditionalContext: !!analysisV2.sideStreamModel ? JSON.stringify({
      sideStreamModel: analysisV2.sideStreamModel
    }) : "",
    ChangeLog: {
      CreatedBy: ((_t = analysisV2.changeLog) == null ? void 0 : _t.createdBy) || "",
      CreatedTime: ((_u = analysisV2.changeLog) == null ? void 0 : _u.createdDateTime) || "",
      LastUpdatedBy: ((_v = analysisV2.changeLog) == null ? void 0 : _v.updatedBy) || "",
      LastUpdatedTime: ((_w = analysisV2.changeLog) == null ? void 0 : _w.updatedDateTime) || ""
    }
  };
};
const getAnalysisScope = (analysisV2) => {
  var _a, _b;
  return {
    PrimaryDataSource: ((_a = analysisV2.analysisTemplate) == null ? void 0 : _a.metricSetName) || "",
    AnalysisType: analysisV2.analysisType || "AB",
    UseFlightAllocationIdFilter: null,
    Flights: getFlightsInfo(analysisV2.experimentMetadata.variants),
    Filters: getFiltersInfo(analysisV2.analysisFilters),
    SupportFiles: (_b = analysisV2.supportFiles) == null ? void 0 : _b.map((sf) => {
      return { FilePath: sf.filePath, FileType: sf.fileType };
    })
  };
};
const getFlightsInfo = (variants) => {
  return variants.map((variant) => {
    var _a, _b;
    return {
      FlightName: variant.name,
      Numberline: ((_a = variant.numberline) == null ? void 0 : _a.name) || "",
      IsControl: variant.isControl,
      Buckets: variant.buckets || "",
      NumberlineSalt: ((_b = variant.numberline) == null ? void 0 : _b.numberlineSalt) || "",
      Seed: variant.seed || ""
    };
  });
};
const getFiltersInfo = (filters) => {
  return filters.map((filter) => {
    return {
      Dimension: filter.name,
      Origin: getOrigin(filter.origin),
      Operator: filter.operator.toString(),
      Values: filter.values,
      TriggerFilterSideStreamInfo: getTriggerFilterSideStreamInfo(filter.triggerFilterSideStreamInfo)
    };
  });
};
const getOrigin = (origin) => {
  switch (origin) {
    case Origin.AnalysisTemplate:
      return "Template";
    case Origin.Experiment:
      return "ExpMan";
    default:
      return origin.toString();
  }
};
const getTriggerFilterSideStreamInfo = (triggerFilterSideStreamInfo) => {
  var _a;
  if (!triggerFilterSideStreamInfo) {
    return void 0;
  }
  return {
    AvailabilityStream: triggerFilterSideStreamInfo.availabilityStream,
    JoinColumnPairs: triggerFilterSideStreamInfo.joinColumnPairs,
    Location: triggerFilterSideStreamInfo.location,
    CustomParameters: (_a = triggerFilterSideStreamInfo.customParameters) == null ? void 0 : _a.map((customParam) => {
      return {
        Name: customParam.name,
        Type: customParam.type,
        Value: customParam.value
      };
    })
  };
};
const convertToRawStudyTaskEntity = (scorecardRequest) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u;
  return {
    Id: +scorecardRequest.taskId,
    // Add dummy values if analysis is not a one off.
    DateRange: {
      Start: scorecardRequest.dateRangeUnit.startUnit,
      End: scorecardRequest.dateRangeUnit.endUnit,
      Unit: scorecardRequest.dateRangeUnit.timeUnit
    },
    ComputedAbsoluteAnalysisRange: {
      Start: ((_b = (_a = scorecardRequest.analysisPeriod) == null ? void 0 : _a.startDateTime) == null ? void 0 : _b.toString()) || "",
      End: ((_d = (_c = scorecardRequest.analysisPeriod) == null ? void 0 : _c.endDateTime) == null ? void 0 : _d.toString()) || ""
    },
    Priority: "Normal",
    // Priority is a legacy concept and deprecated in vNext and Metric service analysis template.
    State: mapStateToLegacy(scorecardRequest.state),
    ScorecardId: +scorecardRequest.id > 0 ? +scorecardRequest.id : null,
    XCardLink: scorecardRequest.scorecardLink,
    ScorecardLink: scorecardRequest.scorecardLink,
    ScorecardAvailableTime: scorecardRequest.scorecardAvailableDateTime || "",
    ScorecardNotificationEnabled: !!((_e = scorecardRequest.notificationConfig) == null ? void 0 : _e.scorecardNotificationEnabled),
    CustomNotifyAliases: (_f = scorecardRequest.notificationConfig) == null ? void 0 : _f.notifiers,
    StudyId: +scorecardRequest.analysisId,
    ExperimentStepId: ((_g = scorecardRequest.experimentMetadata) == null ? void 0 : _g.experimentStepId) || "",
    AdditionalContext: null,
    DateRangeRoundingRuleOverride: null,
    AnalysisItemId: scorecardRequest.analysisRequestId,
    ForceRun: false,
    TaskCost: {},
    EstimatedArrival: {},
    StateInfo: {
      OverallState: mapStateToLegacy(scorecardRequest.state),
      SubState: "",
      AnalysisItemId: scorecardRequest.analysisRequestId || null,
      LastUpdatedTime: ((_h = scorecardRequest.changeLog) == null ? void 0 : _h.updatedDateTime) || ""
    },
    AnalysisConfiguration: getAnalysisConfiguration(scorecardRequest.analysisConfiguration),
    ExecutionConfigurationOverrides: {
      AdjustedCosmosPriority: ((_i = scorecardRequest.computeConfig) == null ? void 0 : _i.adjustedCosmosPriority) || null,
      ComputePipelineRuntimeConfiguration: null,
      ComputePipelineType: ((_k = (_j = scorecardRequest.computeConfig) == null ? void 0 : _j.computePipelineType) == null ? void 0 : _k.toString()) || "Cosmos",
      CosmosPriority: ((_l = scorecardRequest.computeConfig) == null ? void 0 : _l.cosmosPriority) || null,
      IsPreviewScorecard: !!((_m = scorecardRequest.computeConfig) == null ? void 0 : _m.isPreviewScorecard),
      ScorecardPurposeUsedForPrioritization: ((_o = (_n = scorecardRequest.computeConfig) == null ? void 0 : _n.scorecardPurposeUsedForPrioritization) == null ? void 0 : _o.toString()) || "",
      VC: ((_p = scorecardRequest.computeConfig) == null ? void 0 : _p.vc) || ""
    },
    CreatedBy: ((_q = scorecardRequest.changeLog) == null ? void 0 : _q.createdBy) || "",
    ChangeLog: {
      CreatedBy: ((_r = scorecardRequest.changeLog) == null ? void 0 : _r.createdBy) || "",
      CreatedTime: ((_s = scorecardRequest.changeLog) == null ? void 0 : _s.createdDateTime) || "",
      LastUpdatedBy: ((_t = scorecardRequest.changeLog) == null ? void 0 : _t.updatedBy) || "",
      LastUpdatedTime: ((_u = scorecardRequest.changeLog) == null ? void 0 : _u.updatedDateTime) || ""
    }
  };
};
const getAnalysisConfiguration = (analysisConfig) => {
  var _a;
  return {
    Type: "Foray",
    // Always Foray
    UseSampleLog: (analysisConfig == null ? void 0 : analysisConfig.useSampleLog) || false,
    CustomSegments: ((_a = analysisConfig == null ? void 0 : analysisConfig.customSegments) == null ? void 0 : _a.map((cs) => {
      return { Name: cs.name, ScopeExpression: cs.scopeExpression };
    })) || [],
    DataSourceParameterOverrides: analysisConfig == null ? void 0 : analysisConfig.dataSourceParameterOverrides,
    IndividualMetrics: analysisConfig == null ? void 0 : analysisConfig.individualMetrics,
    MetricCategories: analysisConfig == null ? void 0 : analysisConfig.metricCategories,
    Segments: analysisConfig == null ? void 0 : analysisConfig.segments,
    StandardMetricGroups: analysisConfig == null ? void 0 : analysisConfig.standardMetricGroups,
    StandardSegmentGroups: analysisConfig == null ? void 0 : analysisConfig.standardSegmentGroups,
    SegmentBy: getSegmentBy(analysisConfig == null ? void 0 : analysisConfig.segmentBy)
  };
};
const getSegmentBy = (segmentSets) => {
  return (segmentSets == null ? void 0 : segmentSets.map((ss) => {
    var _a, _b;
    return {
      Level: ss.level,
      AggregateAll: ss.aggregateAll,
      CustomSegments: ((_a = ss.customSegments) == null ? void 0 : _a.map((cs) => {
        return { Name: cs.name, ScopeExpression: cs.scopeExpression };
      })) || [],
      SegmentGroups: ss.segmentGroups,
      Segments: ((_b = ss.segments) == null ? void 0 : _b.map((segment) => {
        return {
          Name: segment.name,
          CardinalityLimit: segment.cardinalityLimit || null,
          AllowedValues: null,
          NameForTruncatedSegmentValues: null
        };
      })) || []
    };
  })) || [];
};
const convertToV2StudyAbstract = (analysisV2, totalRecordsCnt = 0) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s;
  const userDefinedFilter = getUserDefinedFilters(analysisV2.analysisFilters, analysisV2.analysisTemplate.name);
  return {
    StudyId: +analysisV2.id,
    Name: (_a = analysisV2.analysisTemplate) == null ? void 0 : _a.name,
    Description: analysisV2.name,
    ExperimentStepId: (_b = analysisV2.experimentMetadata) == null ? void 0 : _b.experimentStepId,
    StartDateTime: ((_d = (_c = analysisV2.analysisPeriod) == null ? void 0 : _c.startDateTime) == null ? void 0 : _d.toString()) || null,
    EndDateTime: ((_f = (_e = analysisV2.analysisPeriod) == null ? void 0 : _e.endDateTime) == null ? void 0 : _f.toString()) || null,
    IsActive: analysisV2.state === AnalysisState.Active,
    BaseOnTemplate: (_g = analysisV2.analysisTemplate) == null ? void 0 : _g.name,
    ExperimentAnalysisType: analysisV2.analysisType,
    CreatedTime: ((_h = analysisV2.changeLog) == null ? void 0 : _h.createdDateTime) || "",
    CreatedBy: ((_i = analysisV2.changeLog) == null ? void 0 : _i.createdBy) || "",
    IsUtc: !!((_j = analysisV2.analysisTemplate) == null ? void 0 : _j.isUtc),
    AdditionalContext: "",
    PrimaryDataSource: ((_k = analysisV2.analysisTemplate) == null ? void 0 : _k.metricSetName) || "",
    PrimaryDataSourceIsUtc: !!((_l = analysisV2.analysisTemplate) == null ? void 0 : _l.isUtc),
    Vertical: getVerticalFilterVal(analysisV2.analysisFilters),
    Flights: analysisV2.experimentMetadata.variants.map((variant) => {
      return { FlightName: variant.name, FlightType: variant.isControl ? "C" : "T" };
    }),
    Markets: getMarketsFilterValues(analysisV2.analysisFilters),
    UserDefinedFilters: userDefinedFilter ? { [userDefinedFilter.name]: userDefinedFilter.values[0] } : void 0,
    UserDefinedFilterType: (_m = userDefinedFilter == null ? void 0 : userDefinedFilter.operator) == null ? void 0 : _m.toString(),
    TriggerFilterSidestreamInfo: (userDefinedFilter == null ? void 0 : userDefinedFilter.triggerFilterSideStreamInfo) ? JSON.stringify(getTriggerFilterSideStreamInfo(userDefinedFilter.triggerFilterSideStreamInfo)) : void 0,
    MetricSetVersion: ((_n = analysisV2.analysisTemplate) == null ? void 0 : _n.metricSetVersion) || "",
    MetricSetName: ((_o = analysisV2.analysisTemplate) == null ? void 0 : _o.metricSetName) || "",
    ScopeReferences: analysisV2.supportFiles.filter((sf) => sf.fileType === SupportFileType.ScopeReference).map((sf) => {
      return sf.filePath;
    }),
    ScopeResources: analysisV2.supportFiles.filter((sf) => sf.fileType === SupportFileType.ScopeResource).map((sf) => {
      return sf.filePath;
    }),
    StudyStatus: !analysisV2.status || analysisV2.status.toString() === AnalysisStatus.NotStarted ? "Pending" : analysisV2.status.toString(),
    IsAdvancedAnalysis: !!analysisV2.isAdvancedAnalysis,
    IsOneOff: !!((_q = (_p = analysisV2.analysisTemplate) == null ? void 0 : _p.analysisTemplateOverrides) == null ? void 0 : _q.isOneOff),
    IsRetrospectiveAnalysis: IsRetrospectiveAnalysis(analysisV2.analysisType, analysisV2.analysisTemplate.name || ""),
    IsRetroAA: IsRetrospectiveAA(analysisV2.analysisType, analysisV2.analysisTemplate.name || ""),
    LatestAnalysisTaskAbstract: analysisV2.latestScorecardInfo ? getTaskAbstract(analysisV2.latestScorecardInfo) : null,
    UpComingAnalysisTaskAbstract: analysisV2.state === AnalysisState.Active && analysisV2.upComingScorecardInfo ? getTaskAbstract(analysisV2.upComingScorecardInfo) : null,
    LatestScorecardId: ((_r = analysisV2.latestScorecardInfo) == null ? void 0 : _r.scorecardId) ? +analysisV2.latestScorecardInfo.scorecardId : null,
    IsMetricServiceTemplate: !!analysisV2.analysisTemplate.isMetricServiceTemplate,
    ForayParameters: analysisV2.analysisType === AnalysisType.ForayApp ? getForayAppParameters(analysisV2.analysisFilters) : null,
    AnalysisTaskAbstracts: ((_s = analysisV2.scorecardRequests) == null ? void 0 : _s.length) ? sortScorecardRequests(analysisV2.scorecardRequests).map((scorecardRequest) => {
      return convertToV2StudyTaskAbstract(scorecardRequest);
    }) : [],
    TotalRecordsCnt: totalRecordsCnt
  };
};
const getTaskAbstract = (scorecardInfo) => {
  var _a, _b, _c, _d, _e;
  return {
    TaskId: 1,
    TimeUnit: ((_a = scorecardInfo.dateRangeUnit) == null ? void 0 : _a.timeUnit) || "",
    StartUnit: (_b = scorecardInfo.dateRangeUnit) == null ? void 0 : _b.startUnit,
    EndUnit: (_c = scorecardInfo.dateRangeUnit) == null ? void 0 : _c.endUnit,
    ComputedAbsoluteAnalysisRange: {
      Start: "",
      End: ""
    },
    State: mapStateToLegacy(scorecardInfo.state),
    Priority: "Normal",
    ExecutionConfiguration: {
      AdjustedCosmosPriority: null,
      ComputePipelineRuntimeConfiguration: null,
      ComputePipelineType: "",
      CosmosPriority: null,
      IsPreviewScorecard: false,
      ScorecardPurposeUsedForPrioritization: "",
      VC: ""
    },
    AnalysisConfiguration: getAbstractAnalysisConfiguration(void 0),
    ScorecardId: scorecardInfo.scorecardId ? +scorecardInfo.scorecardId : null,
    XCardLink: scorecardInfo.scorecardLink,
    IsOneOffRange: !((_d = scorecardInfo.dateRangeUnit) == null ? void 0 : _d.startUnit) && !((_e = scorecardInfo.dateRangeUnit) == null ? void 0 : _e.endUnit),
    JobProfileName: scorecardInfo.jobProfileName,
    JobProfileType: scorecardInfo.jobProfileType
  };
};
const IsRetrospectiveAnalysis = (analysisType, templateName) => {
  return analysisType === AnalysisType.SeedFinder || IsRetrospectiveAA(analysisType, templateName);
};
const IsRetrospectiveAA = (analysisType, templateName) => {
  return analysisType === AnalysisType.RetrospectiveAA || analysisType === AnalysisType.AAStream || analysisType === AnalysisType.ForayApp && templateName.startsWith("ForayApp.RetrospectiveAA");
};
const getMarketsFilterValues = (analysisFilters) => {
  var mktFilter = analysisFilters.filter((analysisFilter) => analysisFilter.name.toUpperCase() === "MKT");
  if (mktFilter.length && mktFilter[0].values.length) {
    return mktFilter[0].values;
  }
  return [];
};
const getUserDefinedFilters = (analysisFilters, templateName) => {
  var userDefinedFilters = analysisFilters.filter((analysisFilter) => analysisFilter.operator.startsWith("Custom"));
  if (templateName !== "ForayApp.BingNRT" && userDefinedFilters.length && userDefinedFilters[0].values) {
    return userDefinedFilters[0];
  }
  return void 0;
};
const getVerticalFilterVal = (analysisFilters) => {
  var verticalFilter = analysisFilters.filter(
    (analysisFilter) => analysisFilter.name.toUpperCase() === "SV" && analysisFilter.origin !== Origin.Experiment
  );
  if (verticalFilter.length && verticalFilter[0].values.length) {
    return verticalFilter[0].values[0];
  }
  return null;
};
const getForayAppParameters = (analysisFilters) => {
  return analysisFilters.filter((af) => af.name.startsWith("ForayApp.Parameter")).map((param) => {
    var _a;
    return {
      key: param.name,
      isRequired: includesIgnoreCase(param.name, "ForayApp.Parameter.Optional.") ? false : true,
      displayName: param.name.replace("ForayApp.Parameter.Optional.", "").replace("ForayApp.Parameter.", ""),
      value: ((_a = param.values) == null ? void 0 : _a.length) ? param.values[0].trim() : ""
    };
  });
};
const convertToV2StudyTaskAbstract = (scorecardRequest) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  return {
    TaskId: +scorecardRequest.taskId,
    TimeUnit: scorecardRequest.dateRangeUnit.timeUnit,
    StartUnit: scorecardRequest.dateRangeUnit.startUnit,
    EndUnit: scorecardRequest.dateRangeUnit.endUnit,
    ComputedAbsoluteAnalysisRange: {
      Start: ((_a = scorecardRequest.analysisPeriod.startDateTime) == null ? void 0 : _a.toString()) || "",
      End: ((_b = scorecardRequest.analysisPeriod.endDateTime) == null ? void 0 : _b.toString()) || ""
    },
    State: mapStateToLegacy(scorecardRequest.state),
    StateDescription: scorecardRequest.stateDescription,
    SupportLinks: scorecardRequest.supportLinks,
    Priority: "Normal",
    ExecutionConfiguration: {
      AdjustedCosmosPriority: ((_c = scorecardRequest.computeConfig) == null ? void 0 : _c.adjustedCosmosPriority) || null,
      ComputePipelineRuntimeConfiguration: null,
      ComputePipelineType: ((_e = (_d = scorecardRequest.computeConfig) == null ? void 0 : _d.computePipelineType) == null ? void 0 : _e.toString()) || "Cosmos",
      CosmosPriority: ((_f = scorecardRequest.computeConfig) == null ? void 0 : _f.cosmosPriority) || null,
      IsPreviewScorecard: !!((_g = scorecardRequest.computeConfig) == null ? void 0 : _g.isPreviewScorecard),
      ScorecardPurposeUsedForPrioritization: ((_i = (_h = scorecardRequest.computeConfig) == null ? void 0 : _h.scorecardPurposeUsedForPrioritization) == null ? void 0 : _i.toString()) || "",
      VC: ((_j = scorecardRequest.computeConfig) == null ? void 0 : _j.vc) || ""
    },
    AnalysisConfiguration: getAbstractAnalysisConfiguration(scorecardRequest.analysisConfiguration),
    ScorecardId: scorecardRequest.id ? +scorecardRequest.id : null,
    XCardLink: scorecardRequest.scorecardLink || "",
    IsOneOffRange: scorecardRequest.dateRangeUnit.startUnit === null && scorecardRequest.dateRangeUnit.endUnit === null,
    JobProfileName: scorecardRequest.jobProfileName,
    JobProfileType: scorecardRequest.jobProfileType
  };
};
const getAbstractAnalysisConfiguration = (analysisConfig) => {
  var _a, _b, _c;
  return {
    Type: "Foray",
    // Always Foray
    UseSampleLog: (analysisConfig == null ? void 0 : analysisConfig.useSampleLog) || false,
    CustomSegments: ((_a = analysisConfig == null ? void 0 : analysisConfig.customSegments) == null ? void 0 : _a.map((cs) => {
      return { Name: cs.name, ScopeExpression: cs.scopeExpression };
    })) || [],
    DataSourceParameterOverrides: analysisConfig == null ? void 0 : analysisConfig.dataSourceParameterOverrides,
    IndividualMetrics: analysisConfig == null ? void 0 : analysisConfig.individualMetrics,
    MetricCategories: analysisConfig == null ? void 0 : analysisConfig.metricCategories,
    Segments: ((_b = analysisConfig == null ? void 0 : analysisConfig.segments) == null ? void 0 : _b.length) ? analysisConfig == null ? void 0 : analysisConfig.segments : null,
    StandardMetricGroups: analysisConfig == null ? void 0 : analysisConfig.standardMetricGroups,
    StandardSegmentGroups: analysisConfig == null ? void 0 : analysisConfig.standardSegmentGroups,
    SegmentBy: ((_c = analysisConfig == null ? void 0 : analysisConfig.segmentBy) == null ? void 0 : _c.length) ? getSegmentBy(analysisConfig == null ? void 0 : analysisConfig.segmentBy) : null,
    SideStreamAnalysisFilter: analysisConfig == null ? void 0 : analysisConfig.sideStreamAnalysisFilter
  };
};
const mapStateToLegacy = (state) => {
  switch (state) {
    case ScorecardRequestState.Completed:
      return AnalysisTaskState.CompletedSuccess.toString();
    case ScorecardRequestState.Failed:
      return AnalysisTaskState.CompletedFailure.toString();
    case ScorecardRequestState.Cancelled:
      return AnalysisTaskState.Cancelled.toString();
    case ScorecardRequestState.Running:
      return AnalysisTaskState.Submitted.toString();
    case ScorecardRequestState.SubmittingToPipeline:
      return AnalysisTaskState.Submitting.toString();
    case ScorecardRequestState.ReadyForSubmission:
      return AnalysisTaskState.Ready.toString();
    case ScorecardRequestState.SubmittedToCluster:
      return AnalysisTaskState.SubmittedToCluster.toString();
    case ScorecardRequestState.WaitingForData:
      return AnalysisTaskState.WaitingForData.toString();
    case ScorecardRequestState.WaitingForComputeResource:
      return AnalysisTaskState.WaitingForComputeResource.toString();
    case ScorecardRequestState.CancelledByUser:
      return AnalysisTaskState.CancelledByUser.toString();
    case ScorecardRequestState.CancelledByExP:
      return AnalysisTaskState.CancelledByExP.toString();
    case ScorecardRequestState.CancelledByVC:
      return AnalysisTaskState.CancelledByVC.toString();
    default:
      return AnalysisTaskState.Pending.toString();
  }
};
const sortScorecardRequests = (scorecardRequests) => {
  const sortedScorecardRequests = [];
  const partialScorecardRequests = scorecardRequests.filter((sr) => sr.dateRangeUnit.startUnit === null).sort((a, b) => compareByEnd(a, b));
  sortedScorecardRequests.push(...partialScorecardRequests);
  const regularRequests = scorecardRequests.filter(
    (sr) => sr.dateRangeUnit.startUnit != null && sr.dateRangeUnit.endUnit != null
  );
  const regularByHour = regularRequests.filter((sr) => sr.dateRangeUnit.timeUnit === TimeUnit.Hour).sort((a, b) => compareByStartThenByEnd(a, b));
  sortedScorecardRequests.push(...regularByHour);
  const regularByDay = regularRequests.filter((sr) => sr.dateRangeUnit.timeUnit === TimeUnit.Day).sort((a, b) => compareByStartThenByEnd(a, b));
  sortedScorecardRequests.push(...regularByDay);
  const remainingScorecardRequests = scorecardRequests.filter((sr1) => !sortedScorecardRequests.some((sr2) => sr2.taskId === sr1.taskId)).sort((a, b) => compareByStart(a, b));
  sortedScorecardRequests.push(...remainingScorecardRequests);
  return sortedScorecardRequests;
};
function compareByStart(a, b) {
  var _a, _b;
  const compareStartDateResult = ((_a = a.dateRangeUnit.startUnit) != null ? _a : 0) - ((_b = b.dateRangeUnit.startUnit) != null ? _b : 0);
  if (compareStartDateResult == 0 && a.dateRangeUnit.endUnit == b.dateRangeUnit.endUnit) {
    return compareJobProfileType(a.jobProfileType, b.jobProfileType, a.jobProfileName, b.jobProfileName);
  }
  return compareStartDateResult;
}
function compareByEnd(a, b) {
  var _a, _b;
  const compareEndDateResult = ((_a = a.dateRangeUnit.endUnit) != null ? _a : 0) - ((_b = b.dateRangeUnit.endUnit) != null ? _b : 0);
  if (compareEndDateResult == 0 && a.dateRangeUnit.startUnit == b.dateRangeUnit.startUnit) {
    return compareJobProfileType(a.jobProfileType, b.jobProfileType, a.jobProfileName, b.jobProfileName);
  }
  return compareEndDateResult;
}
function compareByStartThenByEnd(a, b) {
  var _a, _b, _c, _d;
  const aSrtUnit = (_a = a.dateRangeUnit.startUnit) != null ? _a : 0;
  const aEndUnit = (_b = a.dateRangeUnit.endUnit) != null ? _b : 0;
  const bSrtUnit = (_c = b.dateRangeUnit.startUnit) != null ? _c : 0;
  const bEndUnit = (_d = b.dateRangeUnit.endUnit) != null ? _d : 0;
  const compareDateResult = aSrtUnit - bSrtUnit || aEndUnit - bEndUnit;
  if (compareDateResult == 0) {
    return compareJobProfileType(a.jobProfileType, b.jobProfileType, a.jobProfileName, b.jobProfileName);
  }
  return compareDateResult;
}
function compareJobProfileType(aJobProfileType, bJobProfileType, aJobProfileName, bJobProfileName) {
  if (aJobProfileType == JobProfileType.Merged) {
    return 1;
  } else if (bJobProfileType == JobProfileType.Merged) {
    return -1;
  }
  if (aJobProfileType == JobProfileType.Regular && bJobProfileType == JobProfileType.Regular) {
    if (!aJobProfileName && bJobProfileName) {
      return -1;
    } else if (aJobProfileName && !bJobProfileName) {
      return 1;
    } else if (aJobProfileName && bJobProfileName) {
      if (aJobProfileName > bJobProfileName) {
        return 1;
      } else if (aJobProfileName < bJobProfileName) {
        return -1;
      }
    }
  }
  return 0;
}
export {
  convertToRawStudy,
  convertToRawStudyTaskEntity,
  convertToV2StudyAbstract,
  convertToV2StudyTaskAbstract,
  sortScorecardRequests
};
//# sourceMappingURL=ContractConverterUtils.js.map
